import { defineMessages } from 'react-intl';

const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dependencyTypeBlocks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'conversation-assistant-message-actions.remove-dependency.card-title',
		defaultMessage: 'Remove plan dependency',
		description: 'Title for the remove plan dependency action card',
	},
	confirmButton: {
		id: 'conversation-assistant-message-actions.remove-dependency.confirm-button',
		defaultMessage: 'Remove',
		description:
			'Text shown on a primary confirmation button in the remove plan dependency action card in Rovo chat. Clicking this button permanently removes the selected dependency.',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.remove-dependency.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Text shown on a button in the remove plan dependency action card in Rovo chat that discards the removal and closes the card.',
	},
	dependencyTypeBlocks: {
		id: 'conversation-assistant-message-actions.remove-dependency.dependency-type-blocks',
		defaultMessage: 'blocks',
		description: 'Default label for the dependency type when not provided',
	},
});

export default messages;
